// @flow

import {havePermission} from "./utils"

export default class BookingPermissions {

  canReadBook(proRole:ProRole = null) {
    return havePermission(
      'booking.book',
      proRole
    );
  }

  canCreateBooking(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canCreateBooking',
      proRole
    );
  }

  canCreateBookingOverLimit(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canCreateBookingOverLimit',
      proRole
    );
  }

  canEditBooking(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canEditBooking',
      proRole
    );
  }

  canConfirmWaitingBooking(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canConfirmWaitingBooking',
      proRole
    );
  }

  canCancelBooking(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canCancelBooking',
      proRole
    );
  }

  canFinalizeBooking(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canFinalizeBooking',
      proRole
    );
  }

  canMarkBookingAsSeen(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canMarkBookingAsSeen',
      proRole
    );
  }

  canEditPeriodStateForDay(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.book.canEditPeriodStateForDay',
      proRole
    );
  }

  canReadBookingSettings(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.settings',
      proRole
    );
  }

  canEditBookingSettings(proRole:ProRole = null): boolean {
    return havePermission(
      'booking.settings.canEditSettings',
      proRole
    );
  }

}
